import * as React from 'react';
import { Autocomplete, TextField } from '@mui/material';


import LibraryBooksIcon from '@mui/icons-material/AutoStories';
import { Link } from "react-router-dom";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { Search } from '@mui/icons-material';

export default function AutoCompleteSwar(props) {
  const [direction ,setdirection]=React.useState();
  let quraaIds = {
    'الفاتحة':"1",
    "البقرة" :"2" , 
    'آل عمران' :"3",
    'النساء':"4" ,
    "المائدة":"5" ,
    'الأنعام' :"6",
    'الأعراف' :"7",
    "الأنفال" :"8",
    "التوبة" :"9",
    'يونس' :"10",
    'هود' :"11",
    "يوسف" :"12",
    'الرعد' :"13",
    'إبراهيم' :"14",
    'الحجر' :"15",
    "النحل" :"16",
    'الإسراء' :"17",
    'الكهف' :"18",
    "مريم" :"19",
    "طه" :"20",
    'الأنبياء' :"21",
    'الحج':"22" ,
    "المؤمنون":"23" ,
    'النور' :"24",
    'الفرقان' :"25",
    'الشعراء' :"26",
    'النمل' :"27",
    "القصص" :"28",
    'العنكبوت' :"29",
    'الروم' :"30",
    'لقمان' :"31",
    "السجدة":"32" ,
    'الأحزاب' :"33",
    'سبأ' :"34",
    "فاطر" :"35",
    "يس" :"36",
    'الصافات':"37" ,
    'سورة ص' :"38",
    "الزمر" :"39",
    'غافر' :"40",
    'فصلت' :"41",
    'الشورى' :"42",
    "الزخرف" :"43",
    'الدخان' :"44",
    'الجاثية' :"45",
    'الأحقاف' :"46",
    'محمد' :"47",
    "الفتح" :"48",
    'الحجرات' :"49",
    'سورة ق' :"50",
    'الذاريات' :"51",
    "الطور" :"52",
    'النجم': "53",
    'القمر':"54" ,
    "الرحمن" :"55",
    "الواقعة" :"56",
    'الحديد' :"57",
    'المجادلة' :"58",
    "الحشر" :"59",
    'الممتحنة' :"60",
    'الصف' :"61",
    "الجمعة" :"62",
    "المنافقون" :"63",
    'التغابن' :"64",
    'الطلاق' :"65",
    "التحريم" :"66",
    'الملك' :"67",
    'القلم' :"68",
    "الحاقة" :"69",
    "المعارج" :"70",
    'نوح' :"71",
    'الجن' :"72",
    "المزمل" :"73",
    'المدثر' :"74",
    'القيامة' :"75",
    'الإنسان' :"76",
    "المرسلات" :"77",
    'النبأ' :"78",
    'النازعات' :"79",
    "عبس" :"80",
    "التكوير" :"81",
    'الإنفطار' :"82",
    'المطففين' :"83",
    "الانشقاق" :"84",
    'البروج' :"85",
    'الطارق' :"86",
    'الأعلى' :"87",
    'الغاشية' :"88",
    "الفجر" :"89",
    'البلد' :"90",
    'الشمس' :"91",
    'الليل' :"92",
    "الضحى" :"93",
    'الشرح' :"94",
    'التين' :"95",
    "العلق" :"96",
    "القدر" :"97",
    'البينة' :"98",
    'الزلزلة' :"99",
    "العاديات" :"100",
    'القارعة' :"101",
    'التكاثر' :"102", 
    'العصر' :"103",
    "الهمزة" :"104",
    'الفيل' :"105",
    'قريش' :"106",
    'الماعون':"107" ,
    'الكوثر' :"108",
    "الكافرون" :"109",
    'النصر' :"110",
    'المسد' :"111",
    'الإخلاص' :"112",
    "الفلق" :"113",
    'الناس' :"114",
    
  };
  

  const top100Films = [
        {label: "الفاتحة" },
        {label: "البقرة" },
        {label: 'آل عمران' },
        {label: 'النساء' },
        {label: "المائدة" },
        {label: 'الأنعام' },
        {label: 'الأعراف' },
        {label: "الأنفال" },
        {label: "التوبة" },
        {label: 'يونس' },
        {label: 'هود' },
        {label: "يوسف" },
        {label: 'الرعد' },
        {label: 'إبراهيم' },
        {label: 'الحجر' },
        {label: "النحل" },
        {label: 'الإسراء' },
        {label: 'الكهف' },
        {label: "مريم" },
        {label: "طه" },
        {label: 'الأنبياء' },
        {label: 'الحج' },
        {label: "المؤمنون" },
        {label: 'النور' },
        {label: 'الفرقان' },
        {label: 'الشعراء' },
        {label: 'النمل' },
        {label: "القصص" },
        {label: 'العنكبوت' },
        {label: 'الروم' },
        {label: 'لقمان' },
        {label: "السجدة" },
        {label: 'الأحزاب' },
        {label: 'سبأ' },
        {label: "فاطر" },
        {label: "يس" },
        {label: 'الصافات' },
        {label: 'سورة ص' },
        {label: "الزمر" },
        {label: 'غافر' },
        {label: 'فصلت' },
        {label: 'الشورى' },
        {label: "الزخرف" },
        {label: 'الدخان' },
        {label: 'الجاثية' },
        {label: 'الأحقاف' },
        {label: 'محمد' },
        {label: "الفتح" },
        {label: 'الحجرات' },
        {label: 'سورة ق' },
        {label: 'الذاريات' },
        {label: "الطور" },
        {label: 'النجم' },
        {label: 'القمر' },
        {label: "الرحمن" },
        {label: "الواقعة" },
        {label: 'الحديد' },
        {label: 'المجادلة' },
        {label: "الحشر" },
        {label: 'الممتحنة' },
        {label: 'الصف' },
        {label: "الجمعة" },
        {label: "المنافقون" },
        {label: 'التغابن' },
        {label: 'الطلاق' },
        {label: "التحريم" },
        {label: 'الملك' },
        {label: 'القلم' },
        {label: "الحاقة" },
        {label: "المعارج" },
        {label: 'نوح' },
        {label: 'الجن' },
        {label: "المزمل" },
        {label: 'المدثر' },
        {label: 'القيامة' },
        {label: 'الإنسان' },
        {label: "المرسلات" },
        {label: 'النبأ' },
        {label: 'النازعات' },
        {label: "عبس" },
        {label: "التكوير" },
        {label: 'الإنفطار' },
        {label: 'المطففين' },
        {label: "الانشقاق" },
        {label: 'البروج' },
        {label: 'الطارق' },
        {label: 'الأعلى' },
        {label: 'الغاشية' },
        {label: "الفجر" },
        {label: 'البلد' },
        {label: 'الشمس' },
        {label: 'الليل' },
        {label: "الضحى" },
        {label: 'الشرح' },
        {label: 'التين' },
        {label: "العلق" },
        {label: "القدر" },
        {label: 'البينة' },
        {label: 'الزلزلة' },
        { label: "العاديات" },
        { label: 'القارعة' },
        { label: 'التكاثر' },
        { label: 'العصر' },
        { label: "الهمزة" },
        { label: 'الفيل' },
        { label: 'قريش' },
        { label: 'الماعون' },
        { label: 'الكوثر' },
        { label: "الكافرون" },
        { label: 'النصر' },
        { label: 'المسد' },
        { label: 'الإخلاص' },
        { label: "الفلق" },
        { label: 'الناس' },  ];

  function selectFun(e){
    let target=e.target.value;
    let id=quraaIds[target]    
    if(id){
    setdirection(`/${props.Dir}/${id}`)
  }
  }

  return (
    <Autocomplete
    sx={{ marginTop: '-20px',marginBottom:'30px' ,border:"1px solid white"}}
    freeSolo
      options={top100Films.map((option) => option.label)}
      renderInput={(params) => (
        
        <TextField
          {...params}
          placeholder={props.Label}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              props.Dir === "read"?<LibraryBooksIcon style={{ color: 'white' }} />:<BorderColorIcon style={{ color: 'white' }} />
            ),
            endAdornment:(
              <Link to={direction}> <Search style={{cursor:"pointer", color:"white" , margin:"5px",borderRadius:"10px"}} /></Link>
            ),
            style: { color: 'white' }
          }}
        />
      )}
      onSelect={selectFun}
      ListboxProps={{
        style: { background: '#27292f', color: 'white' ,fontFamily:"Noto Nastaliq Urdu"}
      }}
      
    />
  );
}
